import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TenantPrintNameConfigDTO,
  TenantPrintNameConfigList,
  TenantPrintNameConfigCreateRequestDTO,
  TenantPrintNameConfigUpdateRequestDTO,
  TenantPrintNameConfigDeleteRequestDTO,
  TenantPrintNameConfigReadByIdRequestDTO,
  TenantPrintNameConfigReadByTenantIdRequestDTO,
  TenantPrintNameConfigUpsertByDocTypeRequestDTO,
  TenantPrintNameConfigGetPrintNameRequestDTO,
  PrintNameDTO
} from './company-print-name-config.interface';
import {
  TenantPrintNameConfig_Create,
  TenantPrintNameConfig_Update,
  TenantPrintNameConfig_Delete,
  TenantPrintNameConfig_ReadAll,
  TenantPrintNameConfig_ReadById,
  TenantPrintNameConfig_ReadByTenantId,
  TenantPrintNameConfig_UpsertByDocType,
  TenantPrintNameConfig_GetPrintNameByDocType
} from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class TenantPrintNameConfigService {

  http = inject(HttpClient);

  TenantPrintNameConfig_Create(data: TenantPrintNameConfigCreateRequestDTO): Observable<TenantPrintNameConfigDTO> {
    return this.http.post<TenantPrintNameConfigDTO>(TenantPrintNameConfig_Create, data);
  }

  TenantPrintNameConfig_Update(data: TenantPrintNameConfigUpdateRequestDTO): Observable<TenantPrintNameConfigDTO> {
    return this.http.post<TenantPrintNameConfigDTO>(TenantPrintNameConfig_Update, data);
  }

  TenantPrintNameConfig_Delete(data: TenantPrintNameConfigDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(TenantPrintNameConfig_Delete, data);
  }

  TenantPrintNameConfig_ReadAll(): Observable<TenantPrintNameConfigList> {
    return this.http.get<TenantPrintNameConfigList>(TenantPrintNameConfig_ReadAll);
  }

  TenantPrintNameConfig_ReadById(data: TenantPrintNameConfigReadByIdRequestDTO): Observable<TenantPrintNameConfigDTO> {
    return this.http.post<TenantPrintNameConfigDTO>(TenantPrintNameConfig_ReadById, data);
  }

  TenantPrintNameConfig_ReadByTenantId(data: TenantPrintNameConfigReadByTenantIdRequestDTO): Observable<TenantPrintNameConfigList> {
    return this.http.post<TenantPrintNameConfigList>(TenantPrintNameConfig_ReadByTenantId, data);
  }

  TenantPrintNameConfig_UpsertByDocType(data: TenantPrintNameConfigUpsertByDocTypeRequestDTO): Observable<TenantPrintNameConfigDTO> {
    return this.http.post<TenantPrintNameConfigDTO>(TenantPrintNameConfig_UpsertByDocType, data);
  }

  TenantPrintNameConfig_GetPrintNameByDocType(data: TenantPrintNameConfigGetPrintNameRequestDTO): Observable<PrintNameDTO> {
    return this.http.post<PrintNameDTO>(TenantPrintNameConfig_GetPrintNameByDocType, data);
  }

}
